/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import React from 'react';
import { CheckCircleFilledIcon, ErrorCircleFilledIcon, HelpCircleFilledIcon, InfoCircleFilledIcon } from 'tdesign-icons-react';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { Loading } from '../loading/index.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-74ef9ead.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-1e4c771d.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';
import '../loading/Loading.js';
import '../_chunks/dep-784849f3.js';
import '../_chunks/dep-d6cc3db8.js';
import 'classnames';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-10140b37.js';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-0508545e.js';
import '../_chunks/dep-5e9bbb71.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-d07435ee.js';
import '../loading/style/index.js';
import '../loading/type.js';

function MessageIcon(_ref) {
  var theme = _ref.theme,
    onCloseBtnClick = _ref.onCloseBtnClick;
  var _useGlobalIcon = useGlobalIcon({
      CheckCircleFilledIcon: CheckCircleFilledIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon,
      HelpCircleFilledIcon: HelpCircleFilledIcon,
      InfoCircleFilledIcon: InfoCircleFilledIcon
    }),
    CheckCircleFilledIcon$1 = _useGlobalIcon.CheckCircleFilledIcon,
    ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon,
    HelpCircleFilledIcon$1 = _useGlobalIcon.HelpCircleFilledIcon,
    InfoCircleFilledIcon$1 = _useGlobalIcon.InfoCircleFilledIcon;
  var iconMap = {
    info: InfoCircleFilledIcon$1,
    success: CheckCircleFilledIcon$1,
    warning: ErrorCircleFilledIcon$1,
    error: ErrorCircleFilledIcon$1,
    question: HelpCircleFilledIcon$1,
    loading: Loading
  };
  var Icon = iconMap[theme];
  if (theme === "loading") {
    return /* @__PURE__ */React.createElement(Icon, {
      loading: true
    });
  }
  return Icon ? /* @__PURE__ */React.createElement(Icon, {
    onClick: function onClick(e) {
      return onCloseBtnClick === null || onCloseBtnClick === void 0 ? void 0 : onCloseBtnClick({
        e: e
      });
    }
  }) : null;
}

export { MessageIcon as default };
//# sourceMappingURL=MessageIcon.js.map
